// @flow
import React, { PureComponent } from 'react';
import { StyleSheet } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import { Frame } from '../common';
import theme from '../../theme-config';

import type { NavigationRoute, NavigationScreenProp } from '@react-navigation/compat';

export default class WarningFrame extends PureComponent<Props> {
  styles = getStyles();

  render() {
    const styles = this.styles;
    return (
      <Frame style={[styles.container, this.props.style]}>
        <Text style={styles.titleText}>{this.props.text}</Text>
        {this.props.Button}
      </Frame>
    );
  }
}

type Props = {
  navigation: NavigationScreenProp<NavigationRoute>,
  Button: Node,
  text: string,
  style?: any,
};

const getStyles = () =>
  StyleSheet.create({
    container: {
      paddingTop: 8,
      paddingBottom: 20,
      paddingHorizontal: 16,
      backgroundColor: theme.errorColor,
      alignItems: 'center',
    },
    titleText: {
      color: 'white',
      fontSize: 16,
      textAlign: 'center',
    },
  });
